import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import _ from "lodash";
const Body = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { PR_delete, PR_data } = value;

          return (
            <div
              className="RR fk "
              style={{
                overflowY: "scroll",
                border: "1px solid white",
                height: "300px",
                scrollMarginBottom: "30px"
              }}
            >
              <ul className="ml-3">
                {PR_data.map((el) => {
                  return (
                    <>
                      {el.display == "block" ? (
                        <>
                          {" "}
                          <li
                            className="fk"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span className="px-5">
                              {el.code}/{el.nrxdolar}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                1
                              </sup>
                              /{el.dolar2}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                2
                              </sup>
                              /{Number(el.nrxdolar * el.rezha).toFixed(2)}$/
                              {Number(el.rezha * 12).toFixed(0)}
                            </span>
                            <br />
                            <span>
                              {
                                <NumberFormat
                                  value={el.nrxdadarzan}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {
                                <NumberFormat
                                  value={el.nrxdinar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {
                                <NumberFormat
                                  value={Number(el.nrxdinar * el.rezha).toFixed(
                                    0
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {el.rezha}d
                            </span>

                            <span
                              className="btn btn-danger ml-5 fk border border-black tc"
                              onClick={(e) => PR_delete(e, el.code)}
                            >
                              X
                            </span>
                          </li>
                        </>
                      ) : el.display == "inline" ? (
                        <>
                          {" "}
                          <li
                            className="fk"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span>
                              {el.code}/{el.nrxdolar}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                1
                              </sup>
                              /{el.dolar2}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                2
                              </sup>
                              /
                              {
                                <NumberFormat
                                  value={Number(el.nrxdolar * el.rezha).toFixed(
                                    2
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              $/
                              {
                                <NumberFormat
                                  value={el.nrxdinar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {
                                <NumberFormat
                                  value={el.nrxiwkarton}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {
                                <NumberFormat
                                  value={el.nrxdadarzan}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {el.rezha}d
                            </span>

                            <span
                              className="btn btn-danger ml-5 fk border border-black tc"
                              onClick={(e) => PR_delete(e, el.code)}
                            >
                              X
                            </span>
                          </li>
                        </>
                      ) : el.display == "dolar" ? (
                        <>
                          {" "}
                          <li
                            className="fk d-flex justify-content-start"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span>{el.name}/</span>
                            <span>
                              {el.code}/ {el.nrxdolar}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                1
                              </sup>
                              /{el.dolar2}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                2
                              </sup>
                              /{Number(el.nrxdolar * el.rezha).toFixed(2)}$/
                              {Number(el.rezha * 12).toFixed(0)}/ {el.rezha}d
                            </span>

                            <span
                              className="btn btn-danger ml-5 fk border border-black tc"
                              onClick={(e) => PR_delete(e, el.code)}
                            >
                              X
                            </span>
                          </li>
                        </>
                      ) : el.display == "dinar" ? (
                        <>
                          {" "}
                          <li
                            className="fk d-flex justify-content-start"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span>{el.name}/</span>
                            <span>
                              {el.code}/
                              {
                                <NumberFormat
                                  value={el.nrxdinar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {
                                <NumberFormat
                                  value={Number(el.nrxdinar * el.rezha).toFixed(
                                    0
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              }
                              ID/
                              {Number(el.rezha * 12).toFixed(0)}/
                              {`${el.rezha}d`}
                            </span>
                            <span
                              className="btn btn-danger ml-5 fk border border-black tc"
                              onClick={(e) => PR_delete(e, el.code)}
                            >
                              X
                            </span>
                          </li>
                        </>
                      ) : (
                        <>
                          {" "}
                          <li
                                    className="fk mt-2"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >

                                    <div style={{ display: "inline-block" }}>
                                      <div style={{ fontSize: `${_.divide(el.font ? el.font : 25, 1)}px`, whiteSpace: "nowrap", lineHeight: "1" }}>
                                        {el.code}/{el.nrxdolar}<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>1</sup>/<NumberFormat
                                          value={el.nrxdinar}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        />/ <NumberFormat
                                          value={el.dinar2}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        /><sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>2</sup>
                                      </div>
                                      <hr style={{
                                        borderBottom: "1px solid black",
                                        width: `${_.multiply(el.font ? el.font : 25, 10)}px`,
                                        margin: "0px"
                                      }}></hr>
                                      <div style={{ fontSize: `${_.divide(el.font ? el.font : 25, 1)}px`, whiteSpace: "nowrap", lineHeight: "1" }}>
                                        {el.rezha}d/ {el.dolar2}<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>2</sup>/<NumberFormat
                                          value={el.nrxdadarzan}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        />/<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>p</sup>{el.dp || ""}<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>d</sup>
                                        <span style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px` }}>/<NumberFormat

                                          value={el.singleSale}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        /></span>
                                      </div>
                                    </div>

                            <span
                              className="btn btn-danger ml-5 fk border border-black tc"
                              onClick={(e) => PR_delete(e, el.code)}
                            >
                              X
                            </span>
                          </li>
                        </>
                      )}
                    </>
                  );
                })}
              </ul>
            </div>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default Body;
